import React from 'react';

import { Skeleton, Stack } from '@mui/material';

const styles = { margin: 5, rowGap: 1 };

const ProbePending = () => (
  <Stack aria-busy="true" aria-label="Loading page" id="single-root-page-pending" sx={styles}>
    <Skeleton animation="wave" height={40} width="40%" />
    <Skeleton animation="wave" height={30} />
    <Skeleton animation="wave" height={30} />
    <Skeleton animation="wave" height={30} width="70%" />
  </Stack>
);

export default ProbePending;
